import Confetti from "react-confetti";
import { useState } from "react";
import {Grid, Typography } from "@mui/material";
import {useParams, useHistory} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import LinearProgress from '@mui/material/LinearProgress';
import { makeStyles } from '@mui/styles';
import Alert from '@mui/material/Alert';
import {AlertTitle} from "@mui/material";
import Button from '@mui/material/Button';

import leap from 'assets/leap.jpeg';
import { setResultAction, setInitiateAction } from 'redux/actions/getFormActions';

const useStyles = makeStyles({
    success_logo: {
        borderRadius: '50px !important',
        width: '250px',
        height: '250px',
        backgroundColor: "#f0c2c254",
        padding: 5,
        marginRight: '23px'
    },
    progress: {
        borderRadius: '50px !important',
        width: '250px',
        height: '10px',
        backgroundColor: "#f0c2c254",
        padding: 5,
        marginRight: '23px'
    }
  });

const Success = (props) => {
    const classes = useStyles();
    const formData = useSelector(state => state.formData);
    const dispatch = useDispatch();
    const [animation, setAnimation] = useState(true);

    setTimeout(() => {
        setAnimation(false)
    }, 10000);

    const handleBack = () => {
        dispatch(setResultAction(null));
        dispatch(setInitiateAction())
        props.handleBack();
    }
    console.log(formData.data.riderName);
    return (
        <Grid item className="py-5">
            <Grid container justifyContent="center">
                <img src={leap} className={classes.success_logo} />
                {formData.result.status === 'pending' && <LinearProgress className={classes.progress}/>}
            </Grid>
            {formData.result.status === 'success' &&
                <>
                    <Grid className="mt-3">
                        <Typography color="primary" variant="h5" align="center" className="py-2">Claim ID: {formData.claimId} Submitted Successful!!!</Typography>
                        <Typography color="primary" variant="h6" align="center" className="py-1">Thank you {formData.data.contactName}, for filing a claim with Leap.</Typography>
                        <Typography color="primary" variant="h6" align="center" className="py-1">We will be reaching out to you shortly at {formData.data.contactEmail} with information regarding your claim!</Typography>
                    </Grid>
                    {animation && <Confetti />}
                </>
            }
            {formData.result.status === 'failed' &&
                <>
                    {formData.result.message === 'isDuplicated' ?
                        <Grid className="mt-3">
                            <Typography color="primary" textAlign="center" variant='h4' sx={{p:1}}>Oops!</Typography>
                            <Typography color="primary" textAlign="center" variant='h5' sx={{p:1}}>It looks like a claim has already been filed on this policy.</Typography>
                            <Typography color="primary" textAlign="center" variant='h5' sx={{p:1}}>Please contact: <a href={"mailto:claims@leapguaranty.co.uk?subject=" + formData.data.riderName} >claims@leapguaranty.co.uk</a></Typography>
                            <Typography color="primary" textAlign="center" variant='h5' sx={{p:1}}>BinderID: {formData.data.riderName}</Typography>
                            <Typography color="primary" textAlign="center" variant='h5' sx={{p:1}}>Claim # {formData.result.data[0].Name}</Typography>
                            <Typography color="primary" textAlign="center" variant='h6' >Created Date {new Date(formData.result.data[0].CreatedDate).getDate()+1}/{new Date(formData.result.data[0].CreatedDate).getMonth()+1}/{new Date(formData.result.data[0].CreatedDate).getFullYear()}</Typography>
                        </Grid>
                    :
                        <Alert
                            severity="error"
                        >
                            <AlertTitle>Error</AlertTitle>
                            {formData.result.message}
                        </Alert>
                    }
                </>
            }
            {formData.result.status !== 'pending' && 
                <Grid container justifyContent="center">
                    <Button onClick={() => handleBack()} variant="contained" color="primary" className="my-2">
                        <Typography variant="body1">File Another Claim</Typography>
                    </Button>
                </Grid>
            }
        </Grid>
    )
}

export default Success;